import { http, ep } from '../../client/http';

export const categoryRepo = {
  get: async () => {
    const res = await http.get(ep('category/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
